import { Customization } from '@eduvision/toolkit';


export const AdminAddLicenseForm: Customization['AdminAddLicenseForm'] = {
	defaultAudienceType: 'TEAM'
};
